<template>
  <section>
    <PulseLoader :loading="true" color="#3F46D6" />
  </section>
</template>
<script lang="ts" setup>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
</script>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  text-align: center;
}
</style>
